<template>
  <div :data-component-name="$options.name">
    <div class="h-50 d-inline-block">
      <img v-lazy="jel_getFichierSrc(content.image)" class="w-100" :alt="content.titre" />

      <p v-if="content.surTitre" v-html="content.surTitre"></p>
      <h3>
        <span v-html="content.titre"></span>
      </h3>
      <p v-html="content.sousTitre"></p>
    </div>
    <div class="h-50 d-inline-block" v-html="content.texte"></div>
  </div>
</template>

<script>
export default {
  name: 'MediaImageImg60txt40',
  props: { content: { type: Object, required: true } },
  data() {
    return {};
  },
  computed: {
    classObject() {
      return {
        rounded: this.content.coinArrondi,
      };
    },
    styleObject() {
      return {
        'background-color':
          this.content.fondCouleur?.field === 'couleurEdit'
            ? this.content.fondCouleur.secBgThemeColor
            : null,
      };
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.row {
  background-position: center;
  background-repeat: no-repeat;
}
.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}
</style>
